import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: "user",
    initialState: {
        loggedIn: false,
        userDetails: {
            id: '',
            parent_id: '',
            first_name: '',
            last_name: '',
            image: '',
            name: '',
            email: '',
            email_verification: '',
            login_type: '',
            email_otp: '',
            folder_name: '',
            referral_code: '',
            user_referral_code: '',
            role: '',
            mobile_no: '',
            country_code: '',
            last_login: '',
            is_2fa_enabled: '',
            recovery_code: '',
            google2fa_secret: '',
            is_login: '',
            deleted_at: '',
            created_at: '',
            updated_at: '',
            timer: "",
            mpin: "",
        },
        is_bookkeeper: false,
        isPopupShown: false,
        isFileCount : null,
        isFilePopupShown: false,
    },
    reducers: {
        setloggedIn: (state, action) => {
            state.loggedIn = action.payload;
        },
        setUserDetails: (state, action) => {
            state.userDetails = action.payload;
        },
        setTimer: (state, action) => {
            state.userDetails.timer = action.payload
        },
        setPopupShown: (state, action) => {
            state.isPopupShown = action.payload
        },
        setFileCount: (state, action) => {
            state.isFileCount = action.payload
        },
        setFilePopupShown: (state, action) => {
            state.isFilePopupShown = action.payload
        },
        setIsBookKeeping: (state, action) => {
            state.is_bookkeeper = action.payload
        },
    },
})

export const { setloggedIn, setUserDetails, setTimer, setPopupShown, setIsBookKeeping, setFileCount, setFilePopupShown } = userSlice.actions;

export default userSlice.reducer;

